import React from 'react'
import { Link } from "react-router-dom";
import HomeAbout from '../home/HomeAbout';
import ChooseUs from '../home/ChooseUs';
import HomeTestimonials from '../home/HomeTestimonials';
import Certificates from '../home/Certificates';



const About = () => {
    return (
        <>
            <div className="page-header dark-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Page Header Box Start */}
                            <div className="page-header-box">
                                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="Contact us" style={{ perspective: 400 }}>
                                    <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                           About Us
                                        </div>
                                    </div>
                                </h1>
                                <nav className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">About Us</li>
                                    </ol>
                                </nav>
                            </div>
                            {/* Page Header Box End */}
                        </div>
                    </div>
                </div>
            </div>

        <HomeAbout />
        <ChooseUs />
        <HomeTestimonials />
        <Certificates />




        </>
    )
}

export default About